/**
 * Route for `manual-approval-affiliate-workflow`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ManualApprovalAffiliateWorkflowPage } from "../features/manual-approval-affiliate-workflow/ManualApprovalAffiliateWorkflowPage";

export const manualApprovalAffiliateWorkflowRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/manual-approval-affiliate-workflow",
	component: ManualApprovalAffiliateWorkflowPage,
});

export default manualApprovalAffiliateWorkflowRoute;
